import { Col, Heading, Row, TextInput } from '@digitools/honest-react';
import React from 'react';
import { formatCurrency, validateCurrencyOptional, decimalDollar } from '../../../../../utils/validationUtils';
import { useFormApi } from 'informed';
import { BorderLessGrayBox } from 'src/components/Formatting/StyledComponents';
import { LciValidationLabels } from '../../../constants/LciValidationLabels';
const DependentCoverageAmount = ({ claimant, event }) => {
    const formApi = useFormApi();
    const handleBlur = (field) => (e) => {
        const val = formApi.getValue(field);
        formApi.setValue(field, decimalDollar(val));
    };
    return (<>
      <BorderLessGrayBox>
        <Heading elemType='h3' elemStyle='h4'>Dependent coverage amounts</Heading>
      </BorderLessGrayBox>
      <Row>
        <Col lg={4} md={6} sm={12}>
          <TextInput ariaLabelText={'Dependent basic'} field={'policyInfo_dependentBasicAmount'} icon={'usd'} label={'Dependent basic (optional)'} mask={formatCurrency} onBlur={handleBlur('policyInfo_dependentBasicAmount')} type={'text'} validate={(value) => validateCurrencyOptional(value, LciValidationLabels.dependentBasic)} validateOnChange={true}/>
        </Col>
        <Col lg={4} md={6} sm={12}>
          <TextInput ariaLabelText={'Dependent basic AD&D'} field={'policyInfo_dependentBasicADandDAmount'} icon={'usd'} label={'Dependent basic AD&D (optional)'} mask={formatCurrency} onBlur={handleBlur('policyInfo_dependentBasicADandDAmount')} type={'text'} validate={(value) => validateCurrencyOptional(value, LciValidationLabels.dependentBasicADD)} validateOnChange={true}/>
        </Col>
        <Col lg={4} md={6} sm={12}>
          <TextInput ariaLabelText={'Dependent optional'} field={'policyInfo_dependentOptionalAmount'} icon={'usd'} label={'Dependent optional (optional)'} mask={formatCurrency} onBlur={handleBlur('policyInfo_dependentOptionalAmount')} type={'text'} validate={(value) => validateCurrencyOptional(value, LciValidationLabels.dependentOptional)} validateOnChange={true}/>
        </Col>
      </Row>
      <Row className='mt-0'>
        <Col lg={4} md={6} sm={12}>
          <TextInput ariaLabelText={'Dependent optional AD&D'} field={'policyInfo_dependentOptionalADandDAmount'} icon={'usd'} label={'Dependent optional AD&D (optional)'} mask={formatCurrency} onBlur={handleBlur('policyInfo_dependentOptionalADandDAmount')} type={'text'} validate={(value) => validateCurrencyOptional(value, LciValidationLabels.dependentOptionalADD)} validateOnChange={true}/>
        </Col>
      </Row>
    </>);
};
export default DependentCoverageAmount;
